import {useAppSelector} from 'app/store'
import classNames from 'classnames'
import {usePoliciesQuery} from 'features/Policies/usePolicyQuery'
import {usePolicy} from 'hooks'
import {Policy} from 'interfaces'
import {useLocation} from 'react-router'
import {NavLink} from '../LeftNavLink'
import {CanIAccess, PERMISSIONS} from 'rbac'

export function PoliciesLeftNavigation() {
  const {selectedPolicyName} = useAppSelector(rdxSt => rdxSt.policies)
  const location = useLocation<{policyName: string}>()
  const {pathname} = location
  usePoliciesQuery()

  const {isBasePolicyToBeColored} = usePolicy()

  return (
    <div
      className={classNames('flex flex-col items-start pt-3 px-5 h-full', {
        'bg-dope-teal-100': isBasePolicyToBeColored,
      })}
    >
      <NavLink
        pathname="/policies/content"
        first
        current={pathname === '/policies/content'}
        linkName="Content"
        currentPolicyName={selectedPolicyName}
      />
      <CanIAccess reqPermissions={[PERMISSIONS.VIEW_POLICY_USERS.READ]}>
        <NavLink
          pathname="/policies/users"
          first
          current={pathname === '/policies/users'}
          linkName="Users"
          currentPolicyName={selectedPolicyName}
          classNames={`${
            selectedPolicyName === Policy.BasePolicy ? 'hidden' : 'block'
          }`}
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.VIEW_POLICY_CAC.READ]}>
        <NavLink
          pathname="/policies/cloudapp"
          first
          current={pathname === '/policies/cloudapp'}
          linkName="Cloud App"
          currentPolicyName={selectedPolicyName}
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.POLICY_BYPASS.READ]}>
        <NavLink
          pathname="/policies/bypass"
          first
          current={pathname === '/policies/bypass'}
          linkName="Bypass"
          currentPolicyName={selectedPolicyName}
        />
      </CanIAccess>
    </div>
  )
}
